import { render, staticRenderFns } from "./QuestionBankCatagory.vue?vue&type=template&id=8951e588&"
import script from "./QuestionBankCatagory.vue?vue&type=script&lang=js&"
export * from "./QuestionBankCatagory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports